export default "__VITE_ASSET__BuIjdvjE__"